import React, { Component } from "react";
import Header from "../../../../Components/MainLayout/Header";
import { connect } from "react-redux";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";
import Loader from "../../../../Components/MainLayout/Loader";
import MySnackbar from "../../../../Components/MyComponents/MySnackbar";
import HomeworkCard from "./Card";
import moment from "moment";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class UploadedHomework extends Component {
  state = { dateValue: moment().format("YYYY-MM-DD") };
  componentDidMount() {
    this.fetchHomework({
      school: this.props.user.user.school.id,
      status: true,
      user: this.props.user.id,
      homework_date: moment().format("YYYY-MM-DD"),
    });
  }

  fetchHomework = (params = {}) => {
    axios
      .get(`/api/studenthomework`, {
        params: { ...params },
        type: "json",
      })
      .then((res) => {
        this.setState({
          homeWorkData: res.data,
        });
      });
  };
  handleDelete = async (id) => {
    await axios.delete(`/api/studenthomework/${id}`, {});
    this.fetchHomework({
      school: this.props.user.user.school.id,
      status: true,
      user: this.props.user.id,
      homework_date: moment().format("YYYY-MM-DD"),
    });
    this.setState({
      snackMsg: "Homework Deleted Successfully",
      snackbar: true,
    });
    this.handleSnackbar();
  };

  handleSnackbar = () => {
    setTimeout(() => this.setState({ snackbar: false, snackMsg: "" }), 2000);
  };

  handleDateChange = (e) => {
    this.setState({ dateValue: e.target.value, loading: true });

    this.fetchHomework({
      school: this.props.user.user.school.id,
      status: true,
      user: this.props.user.id,
      homework_date: e.target.value,
    });
  };

  render() {
    console.log(this, "jvhvghfgc");
    let { homeWorkData, snackMsg } = this.state;
    return (
      <React.Fragment>
        {this.state.snackbar ? <MySnackbar title={snackMsg} /> : null}
        <div className="container">
          <div className="input-group input-group-sm my-2">
            <input
              className="form-control th-input-primary th-12"
              type="date"
              onChange={this.handleDateChange}
              value={this.state.dateValue}
              max={moment().add(0, "days").format("YYYY-MM-DD")}
            />
          </div>
          {homeWorkData?.map((item) => {
            return (
              <HomeworkCard handleDelete={this.handleDelete} data={item} />
            );
          })}
        </div>
      </React.Fragment>
    );
  }
}
//
// export default UploadedHomework;
export default connect(mapStateToProps)(UploadedHomework);
